module.exports = __webpack_public_path__ + "static/img/layer9.29928c09.png";